exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".facultyName{\n\tpadding-left:px;\n\tborder:10px solid #f2f2f2;\n}\n.facultyNameHead{\n\tfont-weight: bold;\n}\n.facultyImg{\n\tborder:10px solid #f2f2f2;\n}\n.homeTitle{\n\tfont-family: 'Marvel','sans-serif';\n\tfont-size:30px;\n\tline-height:1.3em;\n\tcolor: #444;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/nivedha/Documents/github/sandbox/src/sppu-beta/src/app/academics/facultyDetails.component.css
// module id = ../../../../../src/app/academics/facultyDetails.component.css
// module chunks = main